<template>
  <Modal :title="$t('global.delete-database-user')" @close="close" @confirm="confirm">
    <template #body>
      <div>{{ $t("global.are-you-sure-delete") }}</div>
      <hr />
      <div>{{ data.user.name }}</div>
    </template>
    <template #footer>
      <Btn class="mr-2" variant="light" type="button" :disabled="loading" @click="close">
        {{ $t("global.cancel") }}
      </Btn>
      <Btn variant="danger" @click="confirm" :loading="loading">
        {{ $t("global.delete") }}
      </Btn>
    </template>
  </Modal>
</template>

<script>
import Btn from "@/components/display/Btn";
import Modal from "@/components/display/Modal";
import { ref } from "@vue/composition-api";
import store from "@/store";

export default {
  name: "DbUserDeleteModal",
  components: {
    Modal,
    Btn,
  },
  props: {
    data: {
      type: Object,
      required: true,
      validator: (value) => {
        const hasDbUser = !!value.user && typeof value.user === "object";
        const hasSite = !!value.site && typeof value.site === "object";

        // separate lines to aid debugging
        if (!hasSite) return false;
        if (!hasDbUser) return false;

        return value;
      },
    },
  },
  setup(props, { emit, root }) {
    const loading = ref(false);

    const close = () => {
      emit("close");
    };

    const confirm = () => {
      loading.value = true;

      const siteId = props.data.site.id;
      const name = props.data.user.name;

      store
        .dispatch("databaseUsers/delete", { siteId, name })
        .then(() => {
          store.dispatch("toasts/addToast", {
            variant: "info",
            message: root.$t("toasts.db-user-deleting-message", { name }),
          });
          emit("close");
        })
        .catch(() => {
          store.dispatch("toasts/addToast", {
            variant: "error",
            message: root.$t("toasts.db-user-deleting-error-message", { name }),
          });
        })
        .finally(() => {
          loading.value = false;
        });
    };

    return {
      loading,
      close,
      confirm,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";
</style>
